import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Button } from 'antd'
import * as req from '../../common/requests'

import css from '../../common/Form.css'

export default class OpenDentalSync extends Component {
  static propTypes = {
    practiceId: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      customerKey: null,
      error: false,
      loading: true,
      remoteDb: null,
    }

    this.saveCustomerKey = this.saveCustomerKey.bind(this)
    this.fetchSyncedRemoteDatabase = this.fetchSyncedRemoteDatabase.bind(this)
  }

  async componentWillMount() {
    await this.fetchSyncedRemoteDatabase()
  }

  async fetchSyncedRemoteDatabase() {
    const { practiceId } = this.props
    try {
      const dbs = await req.getRemoteDatabases(practiceId)
      if (dbs.length) {
        const db = dbs[0]
        this.setState({
          customerKey: db.address,
          remoteDb: db,
          loading: false,
        })
      } else {
        this.setState({ loading: false })
      }
    } catch (err) {
      this.setState({ loading: false, error: true })
    }
  }

  async saveCustomerKey() {
    const { practiceId } = this.props
    const { customerKey, remoteDb } = this.state
    const body = {
      practice_id: practiceId,
      address: customerKey,
    }
    try {
      if (remoteDb) {
        await req.updateRemoteDatabase(practiceId, remoteDb.id, body)
        await req.scheduleSync(remoteDb.id)
      } else {
        const newRemoteDb = await req.createRemoteDatabase(practiceId, body)
        await req.scheduleSync(newRemoteDb.id)
      }
      await this.fetchSyncedRemoteDatabase()
    } catch (err) {
      this.setState({ error: true })
    }
  }

  changeCustomerKey = e => {
    this.setState({ customerKey: e.target.value })
  }

  render() {
    const { customerKey, error, loading, remoteDb } = this.state
    const saveSuccess = remoteDb && remoteDb.address === customerKey
    const buttonText = saveSuccess ? 'Saved' : 'Save and Sync'

    return (
      <div>
        {error ? (
          <div> There was an error accessing the backend </div>
        ) : (
          <Form onSubmit={this.handleConnect}>
            <h3>Open Dental Sync</h3>
            <Form.Item label="Customer API Key from Open Dental">
              <Input
                placeholder=""
                value={customerKey}
                name="customerKey"
                className={css.input}
                onChange={this.changeCustomerKey}
              />
            </Form.Item>
            <Button
              htmlType="submit"
              loading={loading}
              disabled={!customerKey}
              type={saveSuccess ? 'primary' : null}
              onClick={this.saveCustomerKey}
            >
              {buttonText}
            </Button>
            {saveSuccess && <p>If this is the first sync of the practice, refresh this page in 1 to 5 minutes to be able to get to the next step, depending on how large you estimate the practice sync to be.</p>}
          </Form>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/OpenDentalSync.js